import * as service from './books';

export default service;
